module.exports = __webpack_public_path__ + "static/works-rawmate-5f4bae69bb14bcded8f3127c47eaad29.jpg";